const STIME_ROLES = ['ran_stime', 'ran_stime_ro']

export const canSeeStimeFields = user => Boolean(user?.admin || STIME_ROLES.some(role => user?.roles?.[role]))

export const canEditStimeFields = user => Boolean(user?.admin || user?.roles?.ran_stime)

export const canEditRans = ({ user, isStime }) => {
  if (!isStime) {
    return true
  } else if (user?.roles?.ran_stime_ro) {
    return false
  }
  return true
}
